import type { ColumnApi, GridApi, GridReadyEvent } from 'ag-grid-community';
import { useCallback, useMemo, useState } from 'react';

export const useGrid = () => {
  const [gridApi, setGridApi] = useState<GridApi | null>(null);
  const [gridColumnApi, setGridColumnApi] = useState<ColumnApi | null>(null);

  const onGridReady = useCallback((params: GridReadyEvent) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  }, []);

  return useMemo(
    () => ({
      gridApi,
      gridColumnApi,
      onGridReady,
    }),
    [gridApi, gridColumnApi, onGridReady],
  );
};
